(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pup-shop-hub"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pup-ride-kit-carousel')) {
    customElements.define('pup-ride-kit-carousel', class PupRideKitCarousel extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;

        this.viewport = this.querySelector('.psh__kit-viewport');
        this.track = this.querySelector('.psh__kit-track');
        this.previousButton = this.querySelector('.psh__kit-arrow--previous');
        this.nextButton = this.querySelector('.psh__kit-arrow--next');
        this.originalSlides = Array.from(this.track?.querySelectorAll('.psh__kit-slide') || []);
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.autoplay = this.dataset.autoplay === 'true' && !this.reducedMotion;
        this.speed = 7 + (Number(this.dataset.speed) || 3) * 7;
        this.offset = 0;
        this.nudgeRemaining = 0;
        this.lastFrame = 0;
        this.isHovered = false;
        this.isFocused = false;
        this.isDragging = false;
        this.dataset.ready = 'true';

        if (!this.viewport || !this.track || this.originalSlides.length < 2) return;

        this.originalSlides.forEach((slide) => {
          const clone = slide.cloneNode(true);
          clone.dataset.carouselClone = 'true';
          clone.setAttribute('aria-hidden', 'true');
          clone.removeAttribute('data-shopify-editor-block');
          clone.querySelectorAll('img').forEach((image) => {
            image.alt = '';
          });
          this.track.appendChild(clone);
        });

        this.onPreviousClick = () => this.nudge(1);
        this.onNextClick = () => this.nudge(-1);
        this.onMouseEnter = () => {
          this.isHovered = true;
        };
        this.onMouseLeave = () => {
          this.isHovered = false;
        };
        this.onFocusIn = () => {
          this.isFocused = true;
        };
        this.onFocusOut = (event) => {
          if (!this.contains(event.relatedTarget)) this.isFocused = false;
        };
        this.onPointerDown = (event) => this.startDrag(event);
        this.onPointerMove = (event) => this.drag(event);
        this.onPointerUp = (event) => this.endDrag(event);
        this.onVisibilityChange = () => {
          this.lastFrame = 0;
        };

        this.previousButton?.addEventListener('click', this.onPreviousClick);
        this.nextButton?.addEventListener('click', this.onNextClick);
        this.addEventListener('mouseenter', this.onMouseEnter);
        this.addEventListener('mouseleave', this.onMouseLeave);
        this.addEventListener('focusin', this.onFocusIn);
        this.addEventListener('focusout', this.onFocusOut);
        this.viewport.addEventListener('pointerdown', this.onPointerDown);
        this.viewport.addEventListener('pointermove', this.onPointerMove);
        this.viewport.addEventListener('pointerup', this.onPointerUp);
        this.viewport.addEventListener('pointercancel', this.onPointerUp);
        document.addEventListener('visibilitychange', this.onVisibilityChange);

        this.resizeObserver = new ResizeObserver(() => this.measure());
        this.resizeObserver.observe(this.viewport);
        this.measure();
        this.frame = requestAnimationFrame((time) => this.animate(time));
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.resizeObserver?.disconnect();
        this.previousButton?.removeEventListener('click', this.onPreviousClick);
        this.nextButton?.removeEventListener('click', this.onNextClick);
        this.removeEventListener('mouseenter', this.onMouseEnter);
        this.removeEventListener('mouseleave', this.onMouseLeave);
        this.removeEventListener('focusin', this.onFocusIn);
        this.removeEventListener('focusout', this.onFocusOut);
        this.viewport?.removeEventListener('pointerdown', this.onPointerDown);
        this.viewport?.removeEventListener('pointermove', this.onPointerMove);
        this.viewport?.removeEventListener('pointerup', this.onPointerUp);
        this.viewport?.removeEventListener('pointercancel', this.onPointerUp);
        document.removeEventListener('visibilitychange', this.onVisibilityChange);
        this.querySelectorAll('[data-carousel-clone]').forEach((clone) => clone.remove());
        delete this.dataset.ready;
      }

      measure() {
        const styles = getComputedStyle(this.track);
        const gap = parseFloat(styles.columnGap || styles.gap) || 0;
        this.step = this.originalSlides[0].getBoundingClientRect().width + gap;
        this.cycleWidth = this.originalSlides.reduce((width, slide) => width + slide.getBoundingClientRect().width, 0) + gap * this.originalSlides.length;
        this.normalizeOffset();
        this.render();
      }

      animate(time) {
        const elapsed = this.lastFrame ? Math.min(time - this.lastFrame, 40) : 0;
        this.lastFrame = time;

        if (Math.abs(this.nudgeRemaining) > .2) {
          const movement = this.nudgeRemaining * Math.min(.24, elapsed / 110);
          this.offset += movement;
          this.nudgeRemaining -= movement;
          this.normalizeOffset();
          this.render();
        } else if (this.autoplay && !this.isHovered && !this.isFocused && !this.isDragging && !document.hidden) {
          this.offset -= this.speed * elapsed / 1000;
          this.normalizeOffset();
          this.render();
        }

        this.frame = requestAnimationFrame((nextTime) => this.animate(nextTime));
      }

      nudge(direction) {
        if (!this.step) return;
        if (this.reducedMotion) {
          this.offset += direction * this.step;
          this.normalizeOffset();
          this.render();
          return;
        }
        this.nudgeRemaining += direction * this.step;
      }

      startDrag(event) {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        this.isDragging = true;
        this.dragStartX = event.clientX;
        this.dragStartOffset = this.offset;
        this.nudgeRemaining = 0;
        this.classList.add('is-dragging');
        this.viewport.setPointerCapture?.(event.pointerId);
      }

      drag(event) {
        if (!this.isDragging) return;
        const distance = event.clientX - this.dragStartX;
        if (Math.abs(distance) > 4) event.preventDefault();
        this.offset = this.dragStartOffset + distance;
        this.normalizeOffset();
        this.render();
      }

      endDrag(event) {
        if (!this.isDragging) return;
        this.isDragging = false;
        this.classList.remove('is-dragging');
        if (this.viewport.hasPointerCapture?.(event.pointerId)) this.viewport.releasePointerCapture(event.pointerId);
      }

      normalizeOffset() {
        if (!this.cycleWidth) return;
        while (this.offset <= -this.cycleWidth) this.offset += this.cycleWidth;
        while (this.offset > 0) this.offset -= this.cycleWidth;
      }

      render() {
        this.track.style.transform = `translate3d(${this.offset}px, 0, 0)`;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pupcruiser-ride-kit-page"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.frk').forEach(function(root){
    var tabs=Array.from(root.querySelectorAll('[data-frk-slide]'));
    var panels=Array.from(root.querySelectorAll('[data-frk-panel]'));
    var count=root.querySelector('[data-frk-count]');
    var active=0;
    function show(index){
      if(!panels.length)return;
      active=(index+panels.length)%panels.length;
      panels.forEach(function(panel,i){panel.classList.toggle('is-active',i===active);});
      tabs.forEach(function(tab,i){tab.classList.toggle('is-active',i===active);tab.setAttribute('aria-selected',i===active?'true':'false');});
      if(count)count.textContent=(active+1)+' / '+panels.length;
    }
    tabs.forEach(function(tab){tab.addEventListener('click',function(){show(Number(tab.dataset.frkSlide));});});
    var next=root.querySelector('[data-frk-next]');
    var prev=root.querySelector('[data-frk-prev]');
    if(next)next.addEventListener('click',function(){show(active+1);});
    if(prev)prev.addEventListener('click',function(){show(active-1);});
    show(0);
  });

  } catch(e) { console.error(e); }
})();
})();
